module.exports = __webpack_public_path__ + "/static/assets/58f9a9c56a9daef1d47ff177f742804e.jpg";